import React, { useState } from "react";
import he from "he";
import Loader from "./loader";
import Icon from "./icon";
import Misc from "../../utils/misc";

interface Props {
    active?: boolean;
    className?: string;
    loaderClassName?: string;
    small?: boolean;
    xsmall?: boolean;
    color?: string;
    outline?: boolean;
    value: any;
    onClick?: () => void;
    disabled?: boolean;
    id?: string;
    hideContainer?: boolean;
    float?: string;
    icon?: string;
    iconClassName?: string;
    ucfirst?: boolean;
}

const Button: React.FC<Props> = ({
    active,
    small,
    xsmall,
    className,
    loaderClassName,
    color = "black",
    outline,
    value,
    onClick,
    disabled = false,
    id = "",
    hideContainer = false,
    float = "",
    icon = "",
    iconClassName = "",
    ucfirst = true,
}) => {
    value = ucfirst ? new Misc().ucfirst(value + "") : value;
    if (active === true) {
        return <Loader type="circle" className={loaderClassName ? (loaderClassName + " " + float ? "float-" + float : "") : "" + float ? "float-" + float : ""} />;
    }

    if (hideContainer) {
        return (
            <button
                id={id ? id : ""}
                disabled={disabled}
                onClick={() => {
                    if (onClick) {
                        onClick();
                    }
                }}
                className={(xsmall ? "_btn-xxs " : "") + " " + (small ? "_btn-xs " : "") + " " + color + " _btn " + (outline ? "_btn-outline " : "_btn-filled ") + className + " d-inline-block position-relative cursor-pointer"}
            >
                {he.decode(value)}
                {icon ? <Icon icon={icon} className={iconClassName} size="sm" /> : <></>}
            </button>
        );
    }
    return (
        <div className="input-container position-relative">
            <button
                id={id ? id : ""}
                disabled={disabled}
                onClick={() => {
                    if (onClick) {
                        onClick();
                    }
                }}
                className={(xsmall ? "_btn-xxs " : "") + " " + (small ? "_btn-xs " : "") + " " + color + " _btn " + (outline ? "_btn-outline " : "_btn-filled ") + className}
            >
                {he.decode(value)}
                {icon ? <Icon icon={icon} size="sm" /> : <></>}
            </button>
        </div>
    );
};

export default Button;
